import { render, staticRenderFns } from "./TvappSeller.vue?vue&type=template&id=a6439bd6&scoped=true&"
import script from "./TvappSeller.vue?vue&type=script&lang=js&"
export * from "./TvappSeller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6439bd6",
  null
  
)

component.options.__file = "TvappSeller.vue"
export default component.exports